import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        backgroundSettingList : [],
    },
    getters: {
        getBackgroundSettingList: state => state.backgroundSettingList,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setBackgroundSettingList(state, { resp }){
            if (resp) {
                state.backgroundSettingList = resp.data.data
            }else{
                state.backgroundSettingList = [{}]
            }
        },
    },
    actions: {
        saveBackground({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/upload/background?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST',
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setState', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getBackgroundSettingList({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/upload/index-background?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setBackgroundSettingList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
